var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"dashboard-container"},[_c('ExcelUploader'),_c('FilterCard',{ref:"FilterCardRef",attrs:{"showExtraFilters":true},on:{"loadProducts":function($event){return _vm.loadProducts($event)}}}),_c('ArticlesTable',{ref:"DataTableRef",on:{"openFilters":function($event){return _vm.openFilters()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }